export default __webpack_public_path__ + "static/media/Money-Heist-Mask-PNG-Image 3.7f750e15.svg";